import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Rubric, RubricCreatePayload, RubricUpdatePayload } from '@mira-avant/mtlibs';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { NumberFieldComponent } from '../../../fields/standard/number-field/number-field.component';

@Component({
	selector: 'app-rubric-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		FormTitleComponent,
		TextFieldComponent,
		NumberFieldComponent,
	],
	templateUrl: './rubric-form.component.html',
	styleUrl: './rubric-form.component.scss',
})
export class RubricFormComponent implements OnInit, OnChanges {
	@Input('rubric') public rubric: Rubric | undefined | null;
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<Rubric> = new EventEmitter<Rubric>();

	public form: FormGroup = this.fb.group({
		code: ['', [Validators.required, Validators.maxLength(255)]],
		label: ['', [Validators.required, Validators.maxLength(255)]],
		display_order: [0, [Validators.required, Validators.min(0)]],
	});

	constructor(private fb: FormBuilder) {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['rubric'] && this.rubric) {
			this.form.patchValue({
				code: this.rubric.code,
				label: this.rubric.label,
				display_order: this.rubric.display_order,
			});
		}
	}

	public async onSubmit(): Promise<void> {
		if (this.form.invalid) {
			console.error('Form is invalid', this.form.errors);
			return;
		}

		const payload: RubricCreatePayload | RubricUpdatePayload = this.form.value;

		try {
			this.onSubmitEmitter.emit(this.form.value);
			this.clear();
		} catch (error) {
			console.error('Error submitting rubric:', error);
		}
	}

	public clear(): void {
		this.form.reset({ display_order: 0 });
	}
}
